/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TaskStatus {
    SUBMITTED = 'SUBMITTED',
    PENDING = 'PENDING',
    IN_PROCESS = 'IN_PROCESS',
    IN_PROCESS_PARSING = 'IN_PROCESS_PARSING',
    IN_PROCESS_KNOWLEDGE = 'IN_PROCESS_KNOWLEDGE',
    IN_PROCESS_DEMO = 'IN_PROCESS_DEMO',
    SUCCESS = 'SUCCESS',
    SUCCESS_PARSING = 'SUCCESS_PARSING',
    SUCCESS_KNOWLEDGE = 'SUCCESS_KNOWLEDGE',
    SUCCESS_DEMO = 'SUCCESS_DEMO',
    FAILURE = 'FAILURE',
    FAILURE_PARSING = 'FAILURE_PARSING',
    FAILURE_KNOWLEDGE = 'FAILURE_KNOWLEDGE',
    FAILURE_DEMO = 'FAILURE_DEMO',
    REVOKED = 'REVOKED',
    RETRY = 'RETRY',
}
